import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

/**
 * Connector metadata, fetched from the server rather than hardcoded.
 *
 * The adapter that does the syncing owns the field list; duplicating it here
 * would let the canvas offer a field the sync does not mirror. Cached for the
 * session because it only changes when a connector is deployed.
 */
let cache = null;

export async function getConnectorTypes() {
  if (cache) return cache;
  try {
    const res = await httpsCallable(functions, 'listConnectorTypes')();
    cache = res?.data?.connectors || [];
  } catch (e) {
    console.error('[connectors] could not load connector types', e);
    cache = [];
  }
  return cache;
}

/** Pull a workspace's connector-backed collections up to date immediately. */
export async function syncConnectorsNow(workspaceId) {
  const res = await httpsCallable(functions, 'syncConnectorsNow')({ workspaceId });
  return res?.data || { success: false, error: 'No response from sync.' };
}
